
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import PagedDataTable from '@/components/PagedDataTable.vue';
import ProductRepository from '@/repositories/webshop/ProductRepository';
import { Sort, SortDirection } from '@/repositories/BaseCrudRepository';

@Component({
    components: { GeneralScaffold, PagedDataTable },
})
export default class ProductListScreen extends Vue {
    @Inject()
    private readonly productRepository!: ProductRepository;

    public get initialSort(): Sort[] {
        return [
            {
                property: 'position',
                direction: SortDirection.ASC,
            },
        ];
    }

    public get headers(): any[] {
        return [
            {
                text: this.$t('general.actions'),
                value: 'action',
                sortable: false,
            },
            {
                text: this.$t('crud.product.defaultName'),
                align: 'left',
                value: 'defaultName',
                sortable: true,
            },
            {
                text: this.$t('crud.product.stock'),
                value: 'stock',
                sortable: true,
            },
            {
                text: this.$t('crud.product.inventoryManagement'),
                value: 'inventoryVerbose',
                sortable: false,
            },
            {
                text: this.$t('crud.product.position'),
                value: 'position',
                sortable: true,
            },
        ];
    }
}
